/**
 * The header's way to the "In this conversation" column: how many records the conversation works on that the person
 * can open, pressed while the column shows. Demo page: /chats (header actions).
 */
import { useQuery } from '@tanstack/react-query';
import { Layers } from 'lucide-react';
import type React from 'react';
import { useEntityOpener } from '../../components/conversations/entities/entity-opener.js';
import { Button } from '../../components/ui/Button.js';
import { listConversationEntitiesOptions } from '../../generated/api/@tanstack/react-query.gen.js';
import { useSimpleRecordsColumn } from './simple-records-state.js';

export const SimpleRecordsButton: React.FC<{ conversationId: string }> = ({ conversationId }) => {
  const opener = useEntityOpener();
  const column = useSimpleRecordsColumn();
  const { data, isError } = useQuery(listConversationEntitiesOptions({ path: { id: conversationId } }));
  // A count that did not load is left out, never shown as zero; the column itself says it could not load.
  const count = isError ? 0 : (data ?? []).filter((entity) => opener?.labelOf(entity.entity)).length;
  const label = count > 0 ? `In this conversation · ${count}` : 'In this conversation';
  return (
    <Button
      variant={column.visible ? 'secondary' : 'ghost'}
      size="sm"
      aria-pressed={column.visible}
      onClick={column.visible ? column.close : column.open}
    >
      <Layers size={14} aria-hidden />
      {label}
    </Button>
  );
};
